"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = void 0;
var prop_1 = __importDefault(require("lodash/fp/prop"));
var configParser_1 = require("./configParser");
var VALUE_SEPARATOR = '\n';
var validateField = function (config) { return function (address) { return function (field) {
    var getConfig = (0, configParser_1.getFieldConfig)(config)((0, prop_1.default)('country')(address))(field);
    var fieldValues = ((0, prop_1.default)(field)(address) || '').split(VALUE_SEPARATOR);
    return fieldValues.reduce(function (result, value, i) {
        var fieldConfig = getConfig(i + 1);
        return result
            && ((0, prop_1.default)('required')(fieldConfig) ? !!value : true)
            && ((0, prop_1.default)('validationRegex')(fieldConfig) ? new RegExp(fieldConfig.validationRegex).test(value) : true);
    }, true);
}; }; };
/**
* Check whether an [[Address]] is valid or not according to the [[CountryConfig]].
*
* ```
* const isValid = validateAddress(CountryConfig)(address);
* ```
* */
var validateAddress = function (config) { return function (address) {
    if (!address || !address.country) {
        return false;
    }
    if (!(0, prop_1.default)(address.country)(config)) {
        throw new Error("Address configuration doesn't found for country: ".concat(address.country));
    }
    var fields = (0, configParser_1.getFields)(config)(address.country);
    if (fields.length === 0) {
        return false;
    }
    var validateAddressField = validateField(config)(address);
    return fields
        .filter(function (field) { return field !== 'country'; })
        .reduce(function (result, field) {
        return result && validateAddressField(field);
    }, true);
}; };
exports.validateAddress = validateAddress;
exports.default = exports.validateAddress;
